<template>
  <div class="user-content" v-loading="loading">
    <el-button type="primary" @click="openEditWin('create')"
      >新建用户</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="编号" width="80"> </el-table-column>
      <el-table-column prop="username" label="用户名" width="140">
      </el-table-column>
      <el-table-column prop="company_name" label="公司名称"></el-table-column>
      <el-table-column prop="contact" label="联系人" width="120">
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话"> </el-table-column>
      <el-table-column label="基础配置" align="center">
        <template slot-scope="scope">
          <i
            class="el-icon-setting pointer"
            @click="openBaseSet(scope.row)"
            title="基础配置"
          ></i>
        </template>
      </el-table-column>
      <!-- <el-table-column label="设备配置" align="center">
        <template slot-scope="scope">
          <i
            class="el-icon-setting pointer"
            @click="openDeviceData(scope.row)"
            title="设备配置"
          ></i>
        </template>
      </el-table-column> -->
      <el-table-column label="栏目配置" align="center">
        <template slot-scope="scope">
          <i
            class="el-icon-setting pointer"
            @click="OpenTree(scope.row.id,scope.row.brc)"
            title="栏目配置"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="120">
        <template slot-scope="scope"
          ><span :style="{ color: arrStateColor[scope.row.status] }">{{
            arrState[scope.row.status]
          }}</span></template
        >
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <i
            @click="(dialogVisible = true), openEditWin(scope.row)"
            class="el-icon-edit pointer mar-r10"
          ></i>
          <!-- <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--添加修改-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加用户' : '修改用户'"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
        ref="dialogRef"
      >
        <div class="user-info">
          <el-form-item label="用户名" prop="username">
            <el-input
              v-model="editOne.username"
              :disabled="editType === 'update'"
            ></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="password">
            <el-input v-model="editOne.password"></el-input>
          </el-form-item>

          <el-form-item label="公司名称" prop="company_name">
            <el-input v-model="editOne.company_name"></el-input>
          </el-form-item>

          <el-form-item label="公司LOGO">
            <el-upload
              ref="upload"
              name="file"
              class="avatar-uploader"
              :action="uploadAction()"
              :limit="1"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              list-type="picture"
              :on-success="handleAvatarSuccess"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传png文件，且不超过500kb</div>
            </el-upload>
          </el-form-item>

          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="editOne.mobile"></el-input>
          </el-form-item>

          <el-form-item label="联系人" prop="contact">
            <el-input v-model="editOne.contact"></el-input>
          </el-form-item>

          <el-form-item label="软件标题" prop="title">
            <el-input v-model="editOne.title"></el-input>
          </el-form-item>

          <el-form-item label="版权信息" prop="copyright">
            <el-input v-model="editOne.copyright" type="textarea"></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input v-model="editOne.remark" type="textarea"></el-input>
          </el-form-item>

          <el-form-item label="是否启用" prop="status">
            <el-switch
              v-model="editOne.status"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用"
            >
            </el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--权限管理-->
    <el-dialog
      class="dialog600"
      v-if="dialogTreeVisible"
      title="权限管理"
      :visible.sync="dialogTreeVisible"
    >
      <el-form
        label-position="left"
        label-width="100px"
      >
        <div class="box-info">
          <el-form-item label="栏目列表" prop="brc">
            <div class="rolePower">
              <el-tree
                style="overflow: auto"
                :data="treeData"
                show-checkbox
                default-expand-all
                node-key="id"
                ref="tree"
                :props="defaultProps"
              >
              </el-tree>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTreeVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="setTree"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--基础配置-->
    <el-dialog
      :title="'基础配置['+baseData.username+']'"
      :visible.sync="baseData.dialogVisible"
      v-if="baseData.dialogVisible"
    >
      <base-set
        :userId="baseData.id"
        ref="baseSet"
        @closeMethod="closeBaseSet"
      ></base-set>
    </el-dialog>

    <!--设备配置-->
    <el-dialog
      :title="'设备配置['+deviceData.username+']'"
      :visible.sync="deviceData.dialogVisible"
      v-if="deviceData.dialogVisible"
    >
      <device-list
        :userId="deviceData.id"
        ref="deviceData"
        @closeMethod="closeDeviceData"
      ></device-list>
    </el-dialog>
  </div>
</template>

<script>
import adminsApi from "@/api/auth/admins";
import baseSet from "@/components/auth/admin/baseSet.vue";
import deviceList from "@/components/auth/admin/deviceList.vue";
export default {
  components: {
    baseSet,
    deviceList
  },
  data() {
    return {
      arrState: ['禁用','启用'],
      arrStateColor: ['#F56C6C','#67C23A'],
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editIndex: -1,
      editOne: {},
      dialogVisible: false,
      dialogTreeVisible: false,
      editOneRule: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
        ],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        title: [{ required: true, message: "请输入软件标题", trigger: "blur" }],
      },

      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      editTree:{},
      baseData:{
        id: null,
        username: '',
        dialogVisible: false
      },
      deviceData:{
        id: null,
        username: '',
        dialogVisible: false
      },
      fileList: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    getTableData(pageIndex) {
      this.loading = true;
      adminsApi.userList(this.pageInfo).then((res) => {
        this.loading = false;
        let resData = res.data.data;
        this.tableData = resData.list;
        this.pageInfo.page = pageIndex;
        this.cnt_all = parseInt(resData.count);
        this.cnt_all = parseInt(resData.count);
      });
    },
    openEditWin(index) {
      if (index === "create") {
        this.fileList= []
        this.editOne = {
          username: "",
          password: "",
          company_name: "",
          logo: "",
          mobile: "",
          contact: "",
          title: "",
          copyright: "",
          remark: "",
          status: "",
        };
        this.editType = "create";
      } else {
        if(index.logo){
          let haveLogo = {
            name: index.company_name,
            url: index.logo
          }
          this.fileList[0]=haveLogo
        }else{
          this.fileList= []
        }

        this.editOne = {
          id: index.id,
          username: index.username,
          password: index.password,
          company_name: index.company_name,
          logo: index.logo,
          mobile: index.mobile,
          contact: index.contact,
          title: index.title,
          copyright: index.copyright,
          remark: index.remark,
          status: index.status,
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          adminsApi.userEdit(this.editOne.id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("修改成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          adminsApi.userAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          adminsApi.userDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //Open 栏目权限
    OpenTree(id,brc) {
      this.dialogTreeVisible = true;
      let brc_arr=brc.split(',')
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(brc_arr)
      })
      this.editTree = {
        id: id,
        brc: brc
      }
    },
    setTree () {
      this.$nextTick(() => {
        let newBrc = this.$refs.tree.getCheckedKeys().toString()
        let newBrc2 = this.$refs.tree.getHalfCheckedKeys().toString()
        newBrc= newBrc +','+ newBrc2
        adminsApi.userEdit(this.editTree.id, {brc:newBrc}).then((res) => {
          if (res.data.code === 1000) {
            this.dialogTreeVisible = false
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
    },
    //栏目权限列表
    getNodeData() {
      adminsApi.getNodeTree().then((res) => {
        if (res.data.code === 1000) {
          this.treeData = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    openBaseSet(value) {
      let newParams = { 
        id: value.id,
        username: value.username,
        dialogVisible: true
      }
      this.baseData = newParams
    },
    closeBaseSet() {
      this.baseData = {
        id: null,
        username: '',
        dialogVisible: false
      }
    },
    openDeviceData(value) {
      let newParams = { 
        id: value.id,
        username: value.username,
        dialogVisible: true
      }
      this.deviceData = newParams
    },
    closeDeviceData() {
      this.deviceData = {
        id: null,
        username: '',
        dialogVisible: false
      }
    },
    uploadAction() {
      return process.env.VUE_APP_BASE_API+'/api/public/uploadFile';
    },
    handleRemove(file, fileList) {
      this.fileList = []
      this.editOne.logo = ''
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleAvatarSuccess(res, file) {
      // console.log('res',res)
      if (res.data.code === 1000) {
        this.$message.success("上传成功");
        this.editOne.logo = res.data.data.file_url;
        this.fileList[0]=res.data.data.file_url;
      } else {
        this.$message.error("错误，" + res.data.message);
      }
    },
    beforeAvatarUpload(file) {
      // console.log('file',file)
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log('testmsg',testmsg)
      const extension = testmsg === "png";
      if (!extension) {
        this.$message({
          message: "公司LOGO只能是png格式的透明图片！",
          type: "error",
        });
      }
      return extension;
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
    this.getNodeData()
  },
};
</script>
<style lang='less'>
.user-content {
  width: 100%;
  position: relative;
  .el-form-item__content {
    height: auto !important;
  }
  .rolePower{
    border:1px solid #dcdfe6;
    padding: 20px;
    border-radius: 4px;
  }
}
</style>